import {
  CUSTOMERS_LOADING,
  SUBMIT_CUSTOMERS_ACTION_DISPATCHER,
  SUBMIT_CUSTOMERS_ACTION_REQUESTED,
  SUBMIT_CUSTOMERS_ERROR_DISPATCHER,
} from "./Action";

const initialState = {
  successData: { customerListFilter: [] ,customeridFilter: [] },
  failureData: {},
  loading: false,
  isLogout: false,
};

const reducer = (state = initialState, action) => {
  const customerCredList = [];
  switch (action.type) {
    case SUBMIT_CUSTOMERS_ACTION_REQUESTED:
      return { ...state, loading: true };
    case SUBMIT_CUSTOMERS_ACTION_DISPATCHER:
      const customerFilterOption = [];
      const customeridFilterOption = [];
      action?.payload?.data?.forEach((e) => {
        customerFilterOption.push({
          value: e.CustomerName,
          id: e.CustomerName,
        });
        customeridFilterOption.push({
          value: e.CustomerName,
          id: e.CustomerId,
        });
      });

      customerFilterOption.sort(function (a, b) {
        var x = a.value.toLowerCase();
        var y = b.value.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });
      customeridFilterOption.sort(function (a, b) {
        var x = a.value.toLowerCase();
        var y = b.value.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
      });

      return {
        ...state,
        successData: {
          customerListFilter: customerFilterOption,
          customeridFilter: customeridFilterOption,
        },
        loading: false,
      };
    case SUBMIT_CUSTOMERS_ERROR_DISPATCHER:
      return {
        ...state,
        failureData: action.payload,
        loading: false,
      };
    case CUSTOMERS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
